export default "Okay, so let's talk a little bit more about how generative image models work.\n"